import { CreatedAtCell } from 'common-front/src/components/cells/createdAtCell';
import { CreatedByCell } from 'common-front/src/components/cells/createdByCell';
import { useHeavent } from 'common-front/src/hooks/useHeavent';
import { Badge } from 'common/src/designSystem/components/badge';
import { LinkText } from 'common/src/designSystem/components/linkText';
import { Cell } from 'common/src/designSystem/components/table/cell';
import { WorkflowsWorkflowFragment } from 'common/src/generated/types';
import { DateTimeService } from 'common/src/services/dateTimeService';
import { useService } from 'common/src/util/dependencies/dependencies';
import { LocaleFormats } from 'common/src/util/luxon';
import { HeaventPaths } from 'common/src/util/paths/heaventPaths';
import { WorkflowsPaths } from 'common/src/util/paths/workflowsPaths';
import { PossibleColumn } from 'common/src/vo/segment';
import { WorkflowsDefaultColumns } from 'common/src/vo/segments/workflowsSegmentsService';
import { getStateBadgeColorIcon } from 'common/src/vo/workflow';
import * as React from 'react';

interface IWorkflowsCellsProps {
    column: PossibleColumn;
    row: WorkflowsWorkflowFragment;
}

export const WorkflowsCells = (props: IWorkflowsCellsProps) => {
    const {
        translate,
        params: { organizationId, eventId }
    } = useHeavent();
    const dateTimeService = useService(DateTimeService);

    return props.column.slug === WorkflowsDefaultColumns.Id ? (
        <Cell width={100}>{props.row.id}</Cell>
    ) : props.column.slug === WorkflowsDefaultColumns.Name ? (
        <Cell>
            <LinkText
                to={WorkflowsPaths.UPDATE({ organizationId, eventId, workflowId: props.row.id })}
            >
                {props.row.name}
            </LinkText>
        </Cell>
    ) : props.column.slug === WorkflowsDefaultColumns.State ? (
        <Cell>
            <Badge {...getStateBadgeColorIcon(props.row.state)}>{translate(props.row.state)}</Badge>
        </Cell>
    ) : props.column.slug === WorkflowsDefaultColumns.Trigger ? (
        <Cell>{translate(props.row.trigger)}</Cell>
    ) : props.column.slug === WorkflowsDefaultColumns.Action ? (
        <Cell>{translate(props.row.action)}</Cell>
    ) : props.column.slug === WorkflowsDefaultColumns.CreatedBy ? (
        <CreatedByCell createdBy={props.row.createdBy} />
    ) : props.column.slug === WorkflowsDefaultColumns.CreatedAt ? (
        <CreatedAtCell insertedAt={props.row.insertedAt} />
    ) : props.column.slug === WorkflowsDefaultColumns.VolunteersSegment ? (
        <Cell>
            {props.row.volunteersSegment ? (
                <LinkText
                    to={HeaventPaths.VOLUNTEERS_SEGMENT(
                        organizationId,
                        eventId,
                        props.row.volunteersSegment.id
                    )}
                >
                    {props.row.volunteersSegment.name}
                </LinkText>
            ) : (
                '-'
            )}
        </Cell>
    ) : props.column.slug === WorkflowsDefaultColumns.ExecutedAt ? (
        <Cell>
            {props.row.executedAt?.isValid
                ? dateTimeService.toLocaleString(
                      props.row.executedAt.toLocal(),
                      LocaleFormats.DateTime
                  )
                : '-'}
        </Cell>
    ) : null;
};
